<template>
	<div class="m-4">
		<div class="text-subtitle-2">{{ $t("dashboard.eventSettings") }}</div>
		<div class="grid grid-cols-2 gap-4">
			<SoftSelect v-model="velUnit" :label="$t('dashboard.units.velocity')" :items="velUnits" />
			<SoftSelect v-model="accUnit" :label="$t('dashboard.units.acceleration')" :items="accUnits" />
			<SoftSelect v-model="oplUnit" :label="$t('dashboard.units.overpressure')" :items="oplUnits" />
		</div>
	</div>
</template>

<script lang="ts">
import { accelerationUnits, overpressureUnits, velocityUnits } from "@soft-db/data-formatter";
import { useModelValue, useRefObjectSync } from "@soft-db/soft-utils";
import { computed, defineComponent, PropType } from "vue";
import {
	defaultVibrationEventSummaryDataOptions,
	VibrationEventSummaryDataOptions,
} from "./vibration-event-summary-data-options";

export default defineComponent({
	name: "VibrationEventSummaryDataConfig",
	props: {
		modelValue: {
			type: Object as PropType<VibrationEventSummaryDataOptions>,
			default: () => ({ ...defaultVibrationEventSummaryDataOptions }),
		},
	},
	setup(props) {
		const valueModel = useModelValue(props);

		const accUnit = useRefObjectSync(valueModel, "accelerationUnit");
		const velUnit = useRefObjectSync(valueModel, "velocityUnit");
		const oplUnit = useRefObjectSync(valueModel, "oplUnit");

		const accUnits = computed(() => [...accelerationUnits]);
		const velUnits = computed(() => [...velocityUnits]);
		const oplUnits = computed(() => [...overpressureUnits]);

		return { accUnit, accUnits, velUnit, velUnits, oplUnit, oplUnits };
	},
});
</script>
